import raidersTheme from './raidersTheme';
import defaultTheme from './defaultTheme';

let isRaider = false;

if (typeof window !== 'undefined') {
  if (window.location.href.indexOf('raiders') > -1) {
    isRaider = true;
  }
}

export default isRaider ? raidersTheme : defaultTheme;
